export default {
  uploading: 'Enviando',
  cancel: 'Cancelar',
  editTitle: 'Editar Modelo de Referência',
  newTitle: 'Novo Modelo de Referência',
  save: 'Salvar',
  create: 'Criar',
  modelCodename: 'Código do Modelo',
  json: 'JSON',
  downloadPkl: 'Baixar arquivo PKL atual',
  choosePklFile: 'Escolher arquivo PKL',
  pklRequired: 'O arquivo PKL é obrigatório',
  codenameRequired: 'O código é obrigatório',
  codenameInvalid: 'O código só pode conter caracteres alfanuméricos, "-" ou "_"',
  codenameExists: 'O código já existe',
  jsonRequired: 'O JSON é obrigatório',
  invalidJson: 'JSON inválido'
}
